export default class FormDataSourceAuthorityType
{
	static Visible = 0;
	static Query = 1;
	static Export = 2;
	static Edit = 3;
	static Save = 4;
	static Add = 5;
	static Delete = 6;
	
	static Attachment = 7;
	
	
	static queryStr = "query";
	static exportStr = "exp";
	static newStr = "_new";
	static saveStr = "save";
	static delStr = "del";
	static editStr = "edit";
	
	static getDSName(type)
	{
		var result = null;
		if(type == FormDataSourceAuthorityType.Query)
			result = "ds_AllowQuery";
		else if(type == FormDataSourceAuthorityType.Export)
			result = "ds_AllowExport";
		else if(type == FormDataSourceAuthorityType.Add)
			result = "ds_AllowAdd";
		else if(type == FormDataSourceAuthorityType.Save)
			result = "ds_AllowSave";
		else if(type == FormDataSourceAuthorityType.Delete)
			result = "ds_AllowDelete";
		else if(type == FormDataSourceAuthorityType.Edit)
			result = "ds_AllowEdit";
		else if(type == FormDataSourceAuthorityType.Attachment)
			result = "ds_AllowAttachment";
		
		return result;
	}

	
	static getXMLName(type)
	{
		var result = null;
		if(type == FormDataSourceAuthorityType.Query)
			result = "query";
		else if(type == FormDataSourceAuthorityType.Export)
			result = "exp";
		else if(type == FormDataSourceAuthorityType.Add)
			result = "_new";
		else if(type == FormDataSourceAuthorityType.Save)
			result = "save";
		else if(type == FormDataSourceAuthorityType.Delete)
			result = "del";
		else if(type == FormDataSourceAuthorityType.Edit)
			result = "edit";
		else if(type == FormDataSourceAuthorityType.Attachment)
			result = "ds_AllowAttachment";
		
		return result;
		
	}
}


// WEBPACK FOOTER //
// ./src/datasource/FormDataSourceAuthorityType.js